export const newUserEndpoint = state => `${state.config.apiUrl}/v1/users`;
export const listUsersEndpoint = state => `${state.config.apiUrl}/v1/users`;
export const currentUserEndpoint = state => `${state.config.apiUrl}/v1/users/me`;
export const sendUserDebugEndpoint = state => `${state.config.apiUrl}/v1/users/me/debug`;

export const updateUserEndpoint = (state, payload) => `${state.config.apiUrl}/v1/users/${payload.id}`;
export const getUserEndpoint = (state, payload) => `${state.config.apiUrl}/v1/users/${payload.id}`;
export const resetUserPasswordEndpoint = (state, payload) =>
    `${state.config.apiUrl}/v1/users/${payload.id}/password-reset`;

export const getCurrentUserEmail = state => (
    state.users.currentUser && state.users.currentUser.email ? state.users.currentUser.email : null);
export const getCurrentUserFullName = state => (
    state.users.currentUser && state.users.currentUser.fullName ? state.users.currentUser.fullName : null);
export const getCurrentUserId = state => (
    state.users.currentUser && state.users.currentUser.id ? state.users.currentUser.id : null);
export const getCurrentUserScopes = state => (
    state.users.currentUser && state.users.currentUser.scope ? state.users.currentUser.scope : []);
export const getCurrentUserIsOkta = state => (
    state.users.currentUser && state.users.currentUser.isOkta ? state.users.currentUser.isOkta : null);



// WEBPACK FOOTER //
// ./src/services/users/selectors.js